const propertiesTitle = (text) => {
  document.title = text
}

export {propertiesTitle}
